import httpClient from '@/api/http-client';

const endpoint = 'api/suppliers';

const suppliersService = {
  getPage: (params) => httpClient.get(endpoint, { params }),

  getById: (id) => httpClient.get(`${endpoint}/${id}`),

  create: (supplier) => httpClient.post(endpoint, supplier),

  update: (supplier) => httpClient.put(`${endpoint}/${supplier.id}`, supplier),

  search: (query) => httpClient.get(`${endpoint}/find/${query}`),

  delete: (supplier) => httpClient.delete(`${endpoint}/${supplier.id}`),
};

export default suppliersService;
